import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { FeatherRotateCcw, FeatherX } from '@subframe/core';
import type { ProcessoArbitralStatus } from '@/features/arbitral';
import { Button, TextArea, IconButton } from '@/shared/components/ui';
const STATUS_REABERTURA: {
  value: ProcessoArbitralStatus;
  label: string;
}[] = [{
  value: 'PROCESSO_DISTRIBUIDO',
  label: 'Processo Distribuído'
}, {
  value: 'TRIAGEM_EM_ANDAMENTO',
  label: 'Triagem em Andamento'
}, {
  value: 'TRIAGEM_CONCLUIDA',
  label: 'Triagem Concluída'
}, {
  value: 'EM_CITACAO',
  label: 'Em Citação'
}, {
  value: 'EM_ANDAMENTO',
  label: 'Em Andamento'
}, {
  value: 'SENTENCA_EMITIDA',
  label: 'Sentença Emitida'
}];
const MOTIVO_MIN = 5;
interface ReabrirProcessoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (novoStatus: ProcessoArbitralStatus, motivo: string) => void;
  isSubmitting?: boolean;
}
export function ReabrirProcessoModal(t0) {
  const $ = _c(51);
  const {
    isOpen,
    onClose,
    onConfirm,
    isSubmitting: t1
  } = t0;
  const isSubmitting = t1 === undefined ? false : t1;
  const [novoStatus, setNovoStatus] = useState("");
  const [motivo, setMotivo] = useState("");
  let t2;
  if ($[0] !== motivo) {
    t2 = motivo.trim();
    $[0] = motivo;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const motivoValido = t2.length >= MOTIVO_MIN;
  const podeConfirmar = Boolean(novoStatus) && motivoValido;
  let t3;
  if ($[2] !== motivo || $[3] !== motivoValido || $[4] !== novoStatus || $[5] !== onConfirm) {
    t3 = () => {
      if (!novoStatus || !motivoValido) {
        return;
      }
      onConfirm(novoStatus, motivo.trim());
    };
    $[2] = motivo;
    $[3] = motivoValido;
    $[4] = novoStatus;
    $[5] = onConfirm;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleConfirm = t3;
  let t4;
  if ($[7] !== onClose) {
    t4 = () => {
      onClose();
      setTimeout(() => {
        setNovoStatus("");
        setMotivo("");
      }, 300);
    };
    $[7] = onClose;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleClose = t4;
  if (!isOpen) {
    return null;
  }
  let t5;
  if ($[9] !== handleClose) {
    t5 = e => e.key === "Escape" && handleClose();
    $[9] = handleClose;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="bg-brand-50 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full"><FeatherRotateCcw className="text-brand-600 h-5 w-5" /></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex items-center gap-4">{t6}<div className="flex flex-col gap-0.5"><h2 id="reabrir-processo-title" className="text-heading-3 font-heading-3 text-default-font">Reabrir processo</h2><p className="text-body text-subtext-color">O processo volta a tramitar no status escolhido. A ação fica registrada.</p></div></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FeatherX />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== handleClose) {
    t9 = <div className="flex items-start justify-between border-b border-solid border-neutral-100 px-6 py-5">{t7}<IconButton variant="neutral-tertiary" icon={t8} onClick={handleClose} /></div>;
    $[14] = handleClose;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <legend className="text-body-bold font-body-bold text-default-font pb-3">Voltar para o status <span className="text-error-500">*</span></legend>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== novoStatus) {
    t11 = STATUS_REABERTURA.map(status => <label key={status.value} className={`flex cursor-pointer items-center gap-3 rounded-lg border border-solid p-3 transition-all ${novoStatus === status.value ? "border-brand-300 bg-brand-50 ring-brand-200 ring-1" : "border-neutral-200 bg-white hover:border-neutral-300 hover:bg-neutral-50"}`}><input type="radio" name="novoStatusReabertura" value={status.value} checked={novoStatus === status.value} onChange={() => setNovoStatus(status.value)} className="text-brand-600 focus:ring-brand-500 h-4 w-4 border-neutral-300" /><span className="text-body text-default-font font-medium">{status.label}</span></label>);
    $[17] = novoStatus;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <fieldset className="flex flex-col">{t10}<div className="flex flex-col gap-2">{t11}</div></fieldset>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <label htmlFor="motivo-reabertura" className="text-body-bold font-body-bold text-default-font">Motivo da reabertura <span className="text-error-500">*</span></label>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = e_0 => setMotivo(e_0.target.value);
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== motivo) {
    t15 = <TextArea><TextArea.Input id="motivo-reabertura" placeholder={"Ex.: cita\xE7\xE3o inv\xE1lida \u2014 senten\xE7a anulada, processo retorna \xE0 fase de cita\xE7\xE3o."} value={motivo} onChange={t14} rows={3} /></TextArea>;
    $[23] = motivo;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== motivo.length || $[26] !== motivoValido) {
    t16 = motivo.length > 0 && !motivoValido ? <span className="text-caption text-error-600">Descreva o motivo (mínimo {MOTIVO_MIN} caracteres).</span> : null;
    $[25] = motivo.length;
    $[26] = motivoValido;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t15 || $[29] !== t16) {
    t17 = <div className="flex flex-col gap-2">{t13}{t15}{t16}</div>;
    $[28] = t15;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t12 || $[32] !== t17) {
    t18 = <div className="flex max-h-[70vh] flex-col gap-6 overflow-y-auto px-6 py-6">{t12}{t17}</div>;
    $[31] = t12;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== handleClose || $[35] !== isSubmitting) {
    t19 = <Button variant="neutral-secondary" onClick={handleClose} disabled={isSubmitting}>Voltar</Button>;
    $[34] = handleClose;
    $[35] = isSubmitting;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  const t20 = !podeConfirmar || isSubmitting;
  let t21;
  if ($[37] !== handleConfirm || $[38] !== isSubmitting || $[39] !== t20) {
    t21 = <Button variant="brand-primary" onClick={handleConfirm} disabled={t20} loading={isSubmitting}>Reabrir processo</Button>;
    $[37] = handleConfirm;
    $[38] = isSubmitting;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t19 || $[42] !== t21) {
    t22 = <div className="flex items-center justify-end gap-2 border-t border-solid border-neutral-100 bg-neutral-50 px-6 py-4">{t19}{t21}</div>;
    $[41] = t19;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t18 || $[45] !== t22 || $[46] !== t9) {
    t23 = <div role="dialog" aria-modal="true" aria-labelledby="reabrir-processo-title" className="animate-in zoom-in-95 flex w-full max-w-[500px] flex-col overflow-hidden rounded-xl bg-white shadow-2xl duration-200">{t9}{t18}{t22}</div>;
    $[44] = t18;
    $[45] = t22;
    $[46] = t9;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t23 || $[49] !== t5) {
    t24 = <div className="animate-in fade-in fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm duration-200" onKeyDown={t5}>{t23}</div>;
    $[48] = t23;
    $[49] = t5;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  return t24;
}